/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useMemo } from "react";
import { SVGIcon, ExtendedTooltip, Text, theme } from "@nordcloud/gnui";
import { StatusValues } from "../types";
import { accountStatusIconProps } from "./constants";

type Props = {
  status: StatusValues;
};

export function AccountStatusIcon({ status }: Props) {
  const { label, description, icon, color } = useMemo(
    () => accountStatusIconProps[status],
    [status]
  );

  return (
    <ExtendedTooltip
      status={color}
      hideTimeout={0}
      position="start"
      caption={
        <>
          <Text weight="bold" mb={0} size="sm" color={theme.color.text.text04}>
            {label}
          </Text>
          <Text mb={0} size="sm" color={theme.color.text.text04}>
            {description}
          </Text>
        </>
      }
    >
      <SVGIcon color={color} name={icon} css={{ verticalAlign: "sub" }} />
    </ExtendedTooltip>
  );
}
